import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

const Subject = () => {
  const dispatch = useDispatch();
  const conversations = useSelector((store) => store.conversations);

  const handleChange = (e) => {
    dispatch({ type: 'UPDATE_CONVERSATIONS_FIELD', field: 'subject', value: e.target.value });
  };

  return (
    <div className="formContainer">
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label>
        Subject: <sup>*</sup>
      </label>
      <input
        name="subject"
        type="text"
        placeholder="Add Text Here"
        maxLength="80"
        onChange={handleChange}
        value={conversations.fields.subject}
      />
    </div>
  );
};

export default Subject;
